import {Injectable} from '@angular/core';

import SeasonState from '@app/core/states/season.state';

@Injectable({providedIn: 'root'})
export default class SeasonFacade {
  public seasons$  = this._state.seasons$;
  public selected$ = this._state.selected$;

  constructor(private readonly _state: SeasonState) {
  }

  public updateSeason(season: string): void {
    this._state.updateSeason(season);
  }
}
